import React from 'react';
import { Select } from 'antd';
import cn from 'classnames';
import Field, { fieldTypes } from '../../../../../../shared/ui/Field';
import { fieldNames } from '../../../config';
import { shutdownAlisaTemplatesQuery } from '../../../../../../shared/api/queries';
import { useAlisaAudioManagerState } from '../../../../../../shared/lib/alisaAudioManager';
import {
  useSetSelectValueSubscription,
  valueTypes,
} from '../../../lib/subscriptions';
import styles from './AlisaTemplate.module.scss';

const { Option } = Select;
const { useShutdownAlisaTemplates } = shutdownAlisaTemplatesQuery;
const fieldName = fieldNames.alisaTemplate;

const AlisaTemplateField = ({
  form,
  initialValue,
  renderAction,
  renderOptionActions,
}) => {
  const { data, isFetching } = useShutdownAlisaTemplates({
    staleTime: Infinity,
  });

  const playingShutdownId = useAlisaAudioManagerState();

  useSetSelectValueSubscription({
    fieldName,
    data,
    valueType: valueTypes.number,
    form,
  });

  const handleChange = (value) => {
    if (data?.length) {
      const template = data.find((template) => template.id === value);

      if (template) {
        const formattedText = template.text.replace(/\\n/g, '\n');

        form.setFieldsValue({
          [fieldNames.alisaText]: formattedText.startsWith('\n')
            ? formattedText.slice(1)
            : formattedText,
        });
      }
    }
  };

  const hasOptionActions = typeof renderOptionActions === 'function';
  const Container = hasOptionActions ? 'div' : 'span';

  return (
    <Field
      className={styles.field}
      fieldType={fieldTypes.select}
      form={form}
      name={fieldName}
      label="Шаблон автоответа"
      decoratorOptions={{
        initialValue: data?.length ? initialValue : undefined,
      }}
      fieldProps={{
        placeholder: 'Выберите шаблон',
        loading: isFetching,
        showSearch: true,
        optionFilterProp: 'searchtext',
        onChange: handleChange,
        optionLabelProp: 'label',
        disabled: Boolean(playingShutdownId),
      }}
      items={data}
      renderAction={renderAction}
      renderOption={(item) => (
        <Option
          key={item.id}
          value={item.id}
          searchtext={item.name}
          label={item.name}
        >
          <Container
            className={cn({
              [styles.container]: hasOptionActions,
            })}
          >
            {item.name}
            {hasOptionActions && item.editable && (
              <div className={styles.actions}>
                {renderOptionActions({ item, actionClassName: styles.action })}
              </div>
            )}
          </Container>
        </Option>
      )}
    />
  );
};

export default AlisaTemplateField;
